(() => {
  if (window.Quilty9Page) { window.Quilty9Page.init(); return; }
  let end = 0, hideExpired = false, tickId, key = '', duration = 0, evergreen = false;
  const pad = n => String(n).padStart(2, '0');
  function save() { try {sessionStorage.setItem(key,String(end));} catch (_) {} }
  function tick() {
    if (!end) return;
    let remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
    // Compte à rebours sans date fixe : arrivé à zéro, il repart pour un nouveau cycle au lieu de s'éteindre
    if (remaining === 0 && evergreen && duration > 0) { end = Date.now() + duration; save(); remaining = Math.floor(duration / 1000); }
    const values = [Math.floor(remaining / 3600), Math.floor(remaining % 3600 / 60), remaining % 60];
    document.querySelectorAll('[data-q9-clock]').forEach(clock => {
      ['h','m','s'].forEach((k,i) => { const el=clock.querySelector(`[data-q9-${k}]`); if(el)el.textContent=pad(values[i]); });
      // Date fixe passée : on masque le bloc entier (libellé compris), jamais un libellé seul sans chiffres
      const hide = hideExpired && remaining === 0, wrap = clock.closest('.q9-kind-timer') || clock;
      wrap.hidden = hide;
      wrap.style.display = hide ? 'none' : '';
    });
  }
  function timer() {
    const header = document.querySelector('[data-q9-header]');
    if (!header) { clearInterval(tickId); return; }
    const fixed = Date.parse(header.dataset.q9End || '');
    hideExpired = header.dataset.q9HideExpired === 'true';
    evergreen = !Number.isFinite(fixed);
    if (!evergreen) end = fixed;
    else {
      key = `emmafy:${header.dataset.q9Key}:deadline`;
      duration = Math.max(0, Number(header.dataset.q9Hours) || 0)*3600000;
      let saved;
      try {saved = Number(sessionStorage.getItem(key));} catch (_) {}
      end = saved > Date.now() ? saved : Date.now()+duration;
      save();
    }
    tick();clearInterval(tickId);tickId=setInterval(tick,1000);
  }
  function carousel(root) {
    if(root.dataset.bound)return;
    root.dataset.bound='true';
    const track=root.querySelector('.q9-track'), cards=[...track.children];
    const prev=root.querySelector('[data-prev]'), next=root.querySelector('[data-next]'), position=root.querySelector('[data-position]');
    const dots=[...root.querySelectorAll('[data-dot]')];
    let active=0,autoId;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const gap=()=>parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    const step=()=>cards[0] ? cards[0].getBoundingClientRect().width + gap() : 1;
    // Nombre de positions réelles : 6 avis et 3 visibles sur ordinateur = 4 positions, 6 sur mobile
    const pages=()=>Math.max(1, cards.length - Math.max(1, Math.round((track.clientWidth + gap()) / step())) + 1);
    const maxLeft=()=>Math.max(0, track.scrollWidth - track.clientWidth);
    function update(){const n=pages();active=track.scrollLeft>=maxLeft()-2?n-1:Math.min(n-1,Math.round(track.scrollLeft/step()));prev.disabled=false;next.disabled=false;position.textContent=`${active+1} / ${n}`;dots.forEach((dot,i)=>{dot.hidden=i>=n;dot.style.display=i>=n?'none':'';dot.setAttribute('aria-current',String(i===active));});}
    // Défilement en boucle : après la dernière position on revient à la première, et inversement
    function go(i){const n=pages();i=((i%n)+n)%n;track.scrollTo({left:Math.min(i*step(),maxLeft()),behavior:reduced?'auto':'smooth'});}
    dots.forEach(dot=>dot.addEventListener('click',()=>go(Number(dot.dataset.dot))));
    prev.addEventListener('click',()=>go(active-1));next.addEventListener('click',()=>go(active+1));
    track.addEventListener('scroll',update,{passive:true});
    track.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();go(active+(e.key==='ArrowRight'?1:-1));}});
    function stop(){clearInterval(autoId);}
    function start(){stop();if(root.dataset.auto==='true'&&!reduced)autoId=setInterval(()=>go(active+1),Math.max(3,Number(root.dataset.interval)||6)*1000);}
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);
    const observer=new ResizeObserver(update);observer.observe(track);
    root.q9Cleanup=()=>{stop();observer.disconnect();};
    update();start();
  }
  function init(){timer();document.querySelectorAll('[data-q9-reviews]').forEach(carousel);}
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',e=>{e.target.querySelectorAll('[data-q9-reviews]').forEach(x=>x.q9Cleanup?.());});
  document.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.q9-review');if(card)card.scrollIntoView({behavior:'auto',block:'nearest',inline:'start'});});
  window.Quilty9Page={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
